import { LoadingButton } from '@mui/lab'
import { Typography } from '@mui/material'
import { webApiService } from '@services/index'
import MUIDataTable from 'mui-datatables'
import React, { useEffect, useState } from 'react'
import ModalInsumoList from './components/ModalInsumoList'

const DeliverySuppliesOTPage = () => {
  const [modal, setModal] = useState({ open: false, idOT: 0 })
  const [data, setData] = useState<any>([])

  const loadData = async () => {
    const data = await webApiService.getOTSuppliesDelivered().then(res => res.data)
    console.log('Data de useEffect => ', data)
    setData(data)
  }

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'solicitados',
      label: 'Cantidad de insumos solicitados',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'entregados',
      label: 'Cantidad de insumos entregados',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'inventory',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <LoadingButton variant='contained' color='warning' className='shadow-none' onClick={() => setModal({ open: true, idOT: tableMeta.rowData[0] })}>Entregar</LoadingButton>
          )
        }
      }
    }
  ]

  useEffect(() => {
    if (!modal.open) {
      loadData()
    }
  }, [modal.open])

  return (
    <div>
      <div className='container-xxl '>
        <div className='row gy-3 my-4'>
          <div className='col-12 my-2'>
            <Typography variant='h6' className='title mb-3'>
              ORDENES CON ENTREGA DE INSUMO PENDIENTE
            </Typography>

            <div className='shadow-sm rounded bg-white p-3'>
              <div className='tabla-ot' data-tour='tabla-ot'>
                <MUIDataTable
                  title=''
                  data={data}
                  columns={columns}
                  options={{ selectableRowsHideCheckboxes: true }}
                />

                {modal.open && <ModalInsumoList modal={modal} setModal={setModal} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeliverySuppliesOTPage
